module.exports = __webpack_public_path__ + "static/visit-3-15cb8af0b38051e461fbd4cf3603c7bf.jpg";